module.exports = __webpack_public_path__ + "static/media/YFU-LP.36c3d62e.png";